import ContainerProject from "./ContainerProject";
import TabPannelProject from "./TabPannelProject";

import {
  Food,
  Pharma,
  Oil,
  Silo,
  Hararati,
  Textile,
  Moxtalef,
  Ejra,
} from "../index";

import { Box } from "@mui/material";

const Pannel = ({ value, handleChange }) => {
  return (
    <>
      <Box>
        <div>
          <ContainerProject>
            <TabPannelProject value={value} index={0}>
              <Food></Food>
            </TabPannelProject>
            <TabPannelProject value={value} index={1}>
              <Pharma></Pharma>
            </TabPannelProject>
            <TabPannelProject value={value} index={2}>
              <Oil></Oil>
            </TabPannelProject>
            <TabPannelProject value={value} index={3}>
              <Silo></Silo>
            </TabPannelProject>
            <TabPannelProject value={value} index={4}>
              <Hararati></Hararati>
            </TabPannelProject>
            <TabPannelProject value={value} index={5}>
              <Textile></Textile>
            </TabPannelProject>
            <TabPannelProject value={value} index={6}>
              <Moxtalef></Moxtalef>
            </TabPannelProject>
            <TabPannelProject value={value} index={7}>
              <Ejra></Ejra>
            </TabPannelProject>
          </ContainerProject>
        </div>
      </Box>
    </>
  );
};
export default Pannel;
